import {Address} from './address';

/**
 * Account class for list representation
 */
export class AccountDTO {
  user: Account;
  canDelete: boolean;
}

/**
 * Account class for list representation
 */
export class Account {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  status: boolean;
  lastConnectionDate: Date;
}

/**
 * Account class for details representations
 */
export class AccountDetails extends Account {
  createdAt: Date;
  temporaryPassword: string;
  phone: string;
  language: string;
  address: Address;
}



// WEBPACK FOOTER //
// ./src/app/models/account.ts